module.exports = __webpack_public_path__ + "images/loadergif_d90abe1.gif";